import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validarCpf(cpf: string): boolean {
    const digits = cpf.replace(/\D/g, '');

    if (digits.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(digits)) return false; // todos iguais

    const calc = (len: number) => {
        const sum = digits
            .slice(0, len)
            .split('')
            .reduce((acc, d, i) => acc + parseInt(d) * (len + 1 - i), 0);
        const rem = sum % 11;
        return rem < 2 ? 0 : 11 - rem;
    };

    return calc(9) === parseInt(digits[9]) && calc(10) === parseInt(digits[10]);
}

export const cpfValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;
    if (!value) return null; // deixa Validators.required cuidar do obrigatório
    return validarCpf(value) ? null : { cpfInvalido: true };
};
